<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'edit_georgian_bar_config' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">

    <!-- Configuration mode -->
    <div class="mode-card" *ngIf="showConfig">
      <div class="mode-label">
        {{ 'configuration_mode' | translate }}
      </div>

      <ion-segment [value]="configType" (ionChange)="onModeChange($event)" mode="md">
        <ion-segment-button value="basic">
          <ion-label>{{ 'HEADER_BASIC' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="manual">
          <ion-label>{{ 'HEADER_MANUAL' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>

    <ng-container *ngIf="this.configType=='basic'" class="contentDiv">
      <p>{{'MUNTINSPACER_NOTE' | translate}}</p>

      <ion-radio-group [value]="muntinspacers1" [(ngModel)]="muntinspacers1" class="card-border">
        <ion-list lines="none">
          <ion-item class="selection-item" button detail="false">
            <ion-radio slot="start" value="0000" labelPlacement="end" mode="md">
              <div class="radio-content">
                <ion-label class="option-label">
                  <p>{{'MUNTINSPACER_FIXED_ADDITION' | translate}}</p>
                </ion-label>
              </div>
            </ion-radio>
          </ion-item>

          <ion-item class="selection-item" button detail="false">
            <ion-radio slot="start" value="0001" labelPlacement="end" mode="md">
              <div class="radio-content">
                <ion-label class="option-label">
                  <p>{{'MUNTINSPACER_WITH_PSI_VALUES' | translate}}</p>
                </ion-label>
              </div>
            </ion-radio>
          </ion-item>
        </ion-list>
      </ion-radio-group>
      <div *ngIf="muntinspacers1=='0001'">
        <div class="card-border">
          <ion-radio-group [value]="muntinspacers2" [(ngModel)]="muntinspacers2">
            <ion-list lines="none">
              <ion-item class="selection-item" button detail="false">
                <ion-radio slot="start" value="0011" labelPlacement="end" mode="md">
                  <div class="radio-content">
                    <ion-label class="option-label">
                      <p>{{'MUNTINSPACER_PLASTIC' | translate}}</p>
                    </ion-label>
                  </div>
                </ion-radio>
              </ion-item>

              <ion-item class="selection-item" button detail="false">
                <ion-radio slot="start" value="0001" labelPlacement="end" mode="md">
                  <div class="radio-content">
                    <ion-label class="option-label">
                      <p>{{'MUNTINSPACER_ALU' | translate}}</p>
                    </ion-label>
                  </div>
                </ion-radio>
              </ion-item>
            </ion-list>
          </ion-radio-group>
        </div>
        <div class="card-border" *ngIf="this.glassGlazing!=2">
          <ion-radio-group [value]="muntinspacers3" [(ngModel)]="muntinspacers3">
            <ion-list lines="none">
              <ion-item class="selection-item" button detail="false">
                <ion-radio slot="start" value="0001" labelPlacement="end" mode="md">
                  <div class="radio-content">
                    <ion-label class="option-label">
                      <p>{{'MUNTINSPACER_SINGLE' | translate}}</p>
                    </ion-label>
                  </div>
                </ion-radio>
              </ion-item>

              <ion-item class="selection-item" button detail="false">
                <ion-radio slot="start" value="0101" labelPlacement="end" mode="md">
                  <div class="radio-content">
                    <ion-label class="option-label">
                      <p>{{'MUNTINSPACER_DOUBLE' | translate}}</p>
                    </ion-label>
                  </div>
                </ion-radio>
              </ion-item>
            </ion-list>
          </ion-radio-group>
        </div>
        <div class="card-border">
          <ion-radio-group [value]="muntinspacers4" [(ngModel)]="muntinspacers4">
            <ion-list lines="none">
              <ion-item class="selection-item" button detail="false">
                <ion-radio slot="start" value="0001" labelPlacement="end" mode="md">
                  <div class="radio-content">
                    <ion-label class="option-label">
                      <p>{{'MUNTINSPACER_DISTANCE_TO_GLASS_2MM' | translate}}</p>
                    </ion-label>
                  </div>
                </ion-radio>
              </ion-item>

              <ion-item class="selection-item" button detail="false">
                <ion-radio slot="start" value="1001" labelPlacement="end" mode="md">
                  <div class="radio-content">
                    <ion-label class="option-label">
                      <p>{{'MUNTINSPACER_DISTANCE_TO_GLASS_4MM' | translate}}</p>
                    </ion-label>
                  </div>
                </ion-radio>
              </ion-item>
            </ion-list>
          </ion-radio-group>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="this.configType=='manual'" class="contentDiv">

      <div class="form-container">
        <div class="select-group">
          <ion-label class="input-label">{{'HEADER_NAME' | translate}}</ion-label>
          <ion-input class="bordered-input" type="text" [(ngModel)]="eManMuntinSpacerName"
            name="eManMuntinSpacerName" (ionInput)="validateForm()" (ionBlur)="validateForm()">
          </ion-input>
        </div>

        <div class="select-group">
          <ion-label class="input-label">{{'HEADER_PSI' | translate}}</ion-label>
          <ion-input class="bordered-input" type="number" [(ngModel)]="eManMuntinSpacerPsi"
            name="eManMuntinSpacerPsi" (ionInput)="validateForm()" (ionBlur)="validateForm()">
          </ion-input>
        </div>
      </div>
    </ng-container>
  </div>
</ion-content>

<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" [disabled]="!isFormValid" expand="block">
      {{'validate' | translate}}
    </ion-button>
  </div>
</ion-footer>